import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resendConversationMessage } from '@/api/conversations';
import { replaceMessageInCache } from './inbox-cache';

/**
 * REENVÍO de un saliente que el canal rechazó (módulo 5).
 *
 * Es la acción del aviso «No se entregó» de la burbuja (`MessageBubble`): el motor guarda la fila
 * aunque Meta la rechace, así que el panel puede decir que NO llegó y ofrecer reintentarla sin
 * reescribir nada. Lo puede usar cualquier miembro, igual que responder a mano.
 *
 * La caché solo se PARCHEA (el mensaje actualiza su `entregado` en su sitio): reenviar no crea una
 * fila nueva ni mueve la conversación en la bandeja. Si el canal vuelve a rechazarlo, el error se
 * pinta en el aviso del panel (502 con el motivo de Meta) y la fila queda como estaba.
 */

export interface ResendMessageInput {
  conversationId: string;
  messageId: string;
}

export function useResendMessage(tenantId: string | null, conversationId: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ conversationId: id, messageId }: ResendMessageInput) =>
      resendConversationMessage(tenantId ?? '', id, messageId),

    onSuccess: (mensaje, variables) => {
      if (!tenantId) return;

      replaceMessageInCache(queryClient, tenantId, variables.conversationId, mensaje);
    },
  });
}
